/* Routing */
import { Link } from "react-router-dom";
/* Components */
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import TabsNavigation from "../../../components/common/navigation/TabsNavigation";
import {useEffect, useState} from "react";
import useAuth from "../../../hooks/useAuth";
import TiptapView from "../../../components/common/input-layout/tiptap/TiptapView";
import {deleteCmsTextFromDb, getCmsTextList, updateCmsTextStatus} from "../../../api/admin/cmsReq";


export default function CmsText({category}) {
    const { auth } = useAuth();
    const token = auth?.token;
    const [filteredText, setFilteredText] = useState();

    const apiCmsTextList = async () => {
        const response = await getCmsTextList(category);
        setFilteredText(response?.data?.filter(text => parseInt(text?.category) === category));
    }

    useEffect(() => {
        apiCmsTextList();
    }, [ category ]);

    const handleDeleteCmsText = (e) => {
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un texte.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce texte ?")) {
                const body = {
                    "cmsTextId": parseInt(id),
                }
                return (
                    deleteCmsTextFromDb(token, body)
                        .then((response) => {
                            response.error ? alert("Le texte n'a pas pu être supprimé.") : alert("Le texte a bien été supprimé.")
                        })
                )
            }
        }
    }

    const handleCmsTextEnable = (e) => {
        if (!auth.roles.includes("ROLE_SUPER_ADMIN")) {
            e.target.setAttribute("disabled", true);
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un texte.");
            e.target.removeAttribute("disabled");
        } else {
            if (e.target.checked === true) {
                let body = {
                    "cmsTextEnabled": false,
                    "cmsTextId": parseInt(e.target.getAttribute("id")),
                }
                alert("Vous venez de rendre visible ce texte.");
                updateCmsTextStatus(token, body)
            }
            if (e.target.checked === false) {
                let body = {
                    "cmsTextEnabled": true,
                    "cmsTextId": parseInt(e.target.getAttribute("id")),
                }
                alert("Vous venez de rendre invisible ce texte.");
                updateCmsTextStatus(token, body)
            }
        }
    };

    let location;
    switch (category) {
        case 3:
            location = "Cms : Mentions légales";
            break;
        case 4:
            location = "Cms : Cookies";
            break;
        case 5:
            location = "Cms : Données personnelles";
            break;
        default:
            location = "Cms : Texte formulaires";
    }

    const sources = "fas fa-balance-scale";

    return (
        <main className="admin">
            <Header parent="Administration"
                    location={location}
                    slug="/admin/accueil"
            />
            <TabsNavigation category={category}/>
            <div>
                <div className="content-container cms-top">
                    <div className="cms-legal column">
                        <Icon source={sources} color="blue" span={location}/>
                        { category === 3 ?
                            <div className="cms-button">
                                <button><Link to="/admin/cms/mentions/legales/0/voir"><i className="fa fa-plus"></i> Ajouter</Link></button>
                                <button><Link to="/admin/cms/mentions/legales/ordonner"><i className="fa fa-sort"></i> Changer l'ordre des textes</Link></button>
                            </div>
                            : category === 4 ?
                                <div className="cms-button">
                                    <button><Link to="/admin/cms/cookies/0/voir"><i className="fa fa-plus"></i> Ajouter</Link></button>
                                    <button><Link to="/admin/cms/cookies/ordonner"><i className="fa fa-sort"></i> Changer l'ordre des textes</Link></button>
                                </div>
                                : category === 5 ?
                                    <div className="cms-button">
                                        <button><Link to="/admin/cms/rgpd/0/voir"><i className="fa fa-plus"></i> Ajouter</Link></button>
                                        <button><Link to="/admin/cms/rgpd/ordonner"><i className="fa fa-sort"></i> Changer l'ordre des textes</Link></button>
                                    </div>
                                    : null
                        }
                        {filteredText?.map((article,index) => (
                            <fieldset key={index}>
                                <ul className="flex cms">
                                    <Link className="button edit-button" to={`${article?.id}/voir`}><i className="fa fa-eye"/></Link>
                                    <i id={article?.id} className="red fa fa-trash delete-button"
                                       onClick={handleDeleteCmsText}></i>
                                    <i
                                        id={article?.id}
                                        className={article?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleCmsTextEnable}
                                        title={article?.enabled ? "Texte visible - Cliquer pour masquer" : "Texte masqué - Cliquer pour rendre visible"}
                                    />
                                </ul>
                                <div className="cms-text-meta">
                                    <div><span>Position : </span>{article?.position}</div>
                                    <div><span>Titre : </span>{article?.hasTitle ? article?.title : "Pas de titre"}</div>
                                    <div><span>Date : </span>{article?.updatedAt}</div>
                                </div>
                                <TiptapView className="html-textarea" content={article?.content}/>
                            </fieldset>
                        ))}
                    </div>
                </div>

            </div>
        </main>
    )
}
